import "./App.css";
import RoutePage from "./Routes/Route";
import { ApolloProvider, InMemoryCache, ApolloClient, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import Cookies from "js-cookie";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { adminTheme } from "./theme/adminTheme";
import { GRAPHQL_URL } from "./constants/api";

function App() {
  const httpLink = createHttpLink({
    uri: GRAPHQL_URL,
    credentials: "include",
  });

  const authLink = setContext((_, { headers }) => {
    const token = Cookies.get("token");
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  return (
    <div className="App">
      <ApolloProvider client={client}>
        <ThemeProvider theme={adminTheme}>
          <CssBaseline />
          <RoutePage />
        </ThemeProvider>
      </ApolloProvider>
    </div>
  );
}

export default App;
